
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alpha/player-shares",
      function () {
        return require("private-next-pages/alpha/player-shares.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alpha/player-shares"])
      });
    }
  